export function buildApiUrlImage(url: string): string | undefined {
  return url ? '/api/images/load/url?url=' + encodeURIComponent(url) : undefined;
}
